import React, { createContext, useContext, useState, useEffect } from 'react';
import { getSession, logout as apiLogout } from '../lib/api/auth';
import supabase from '../supabase/supabase';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshUser = async () => {
    try {
      const sessionUser = await getSession();
      setUser(sessionUser);
      return sessionUser;
    } catch (e) {
      setUser(null);
    }
  };

  const switchHousehold = async (householdId, role) => {
    if (!user) return;
    
    // 1. Update DB so this choice persists across refreshes
    await supabase
      .from('members_20240320')
      .update({ last_active_at: new Date().toISOString() })
      .eq('user_id', user.id)
      .eq('household_id', householdId);

    // 2. Update local state
    setUser(prev => ({ ...prev, householdId, role }));
  };

  useEffect(() => {
    refreshUser().finally(() => setLoading(false));
  }, []);

  const logout = async () => {
    await apiLogout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, logout, loading, refreshUser, switchHousehold }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);